import { Link } from 'react-router-dom';
import ArticleLayout from '@/pages/article/components/ArticleLayout';
import Footer from '@/pages/home/components/Footer';

export default function BasetaoVsCompetitors() {
  return (
    <>
      <ArticleLayout title="Basetao vs Competitors 2026: CSSBuy, Sugargoo, Wegobuy & Pandabuy Compared" subtitle="Objective side-by-side comparison of Basetao against major shopping agents covering fees, shipping, QC quality, warehouse policies, and platform usability." tag="Comparison">
        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Basetao vs The Competition</h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            In a crowded shopping agent market, <strong className="text-foreground-900">Basetao</strong> differentiates itself through superior QC photography and generous warehouse storage terms. While competitors like CSSBuy offer slightly lower service fees, Basetao's 180-day free storage and detailed multi-angle inspection photos provide tangible value that cheaper agents struggle to match.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            Sugargoo has a more polished mobile interface, and Wegobuy benefits from established community trust, but neither matches Basetao's combination of storage duration and QC detail. For a comprehensive feature breakdown, visit the <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline">Basetao Spreadsheet resource hub</Link>.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Feature Comparison Table</h2>
          <div className="overflow-x-auto">
            <div className="min-w-[500px] rounded-lg overflow-hidden border border-background-200/70">
              <div className="grid grid-cols-5 bg-background-200/70">
                {['Feature', 'Basetao', 'CSSBuy', 'Sugargoo', 'Wegobuy'].map((h) => (
                  <div key={h} className="px-4 py-3 text-xs font-semibold text-foreground-800">{h}</div>
                ))}
              </div>
              {[
                ['Free Storage', '180 days', '90 days', '100 days', '100 days'],
                ['QC Photos', '5-7 free', '3 free', '3 free', '3 free'],
                ['Service Fee', '~5%', '~3%', '~5%', '~5%'],
                ['Support', 'Email/Chat', 'Chat/Email', 'Chat', 'Email/Chat'],
              ].map((row, ri) => (
                <div key={ri} className={`grid grid-cols-5 ${ri % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}`}>
                  {row.map((cell, ci) => (
                    <div key={ci} className={`px-4 py-3 text-xs ${ci === 0 ? 'font-semibold text-foreground-800' : ci === 1 ? 'font-semibold text-primary-700' : 'text-foreground-600'}`}>{cell}</div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mb-8">
          <div className="bg-primary-50/50 border border-primary-200/50 rounded-lg p-6 md:p-8 text-center">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Explore All Comparisons</h2>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Back to BasetaoSheet Home</Link>
          </div>
        </section>
      </ArticleLayout>
      <Footer />
    </>
  );
}